import { render, staticRenderFns } from "./HistoryListView.vue?vue&type=template&id=dcc9631a"
import script from "./HistoryListView.vue?vue&type=script&lang=js"
export * from "./HistoryListView.vue?vue&type=script&lang=js"
import style0 from "./HistoryListView.vue?vue&type=style&index=0&id=dcc9631a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports